// ============================================================
// services/atencionPsicologicaService.ts
// /atenciones-psicologicas — CRUD + agenda del psicólogo.
// ============================================================

import { httpClient } from 'utils/httpClient';
import {
  AtencionPsicologicaPayload,
  AtencionPsicologicaResponse,
} from 'types/psicologia.types';

export const atencionPsicologicaService = {

  async crear(payload: AtencionPsicologicaPayload): Promise<AtencionPsicologicaResponse> {
    return httpClient.post<AtencionPsicologicaResponse>('/atenciones-psicologicas', payload);
  },

  async obtener(id: number): Promise<AtencionPsicologicaResponse> {
    return httpClient.get<AtencionPsicologicaResponse>(`/atenciones-psicologicas/${id}`);
  },

  async listarPorMatricula(matriculaId: number): Promise<AtencionPsicologicaResponse[]> {
    const data = await httpClient.get<AtencionPsicologicaResponse[]>(
      `/atenciones-psicologicas/matricula/${matriculaId}`,
    );
    return Array.isArray(data) ? data : [];
  },

  /** Citas del psicólogo autenticado en el rango [desde, hasta] (ISO local). */
  async getAgenda(desde: string, hasta: string, signal?: AbortSignal): Promise<AtencionPsicologicaResponse[]> {
    const q = new URLSearchParams({ desde, hasta });
    const data = await httpClient.get<AtencionPsicologicaResponse[]>(
      `/atenciones-psicologicas/agenda?${q}`,
      signal ? { signal } : undefined,
    );
    return Array.isArray(data) ? data : [];
  },

  async actualizar(id: number, payload: AtencionPsicologicaPayload): Promise<AtencionPsicologicaResponse> {
    return httpClient.put<AtencionPsicologicaResponse>(`/atenciones-psicologicas/${id}`, payload);
  },

  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/atenciones-psicologicas/${id}`);
  },
};
